import { AIBuilderUsageView } from "../../../../Trips"
import { Helmet } from "react-helmet-async"

export default function CreditConsumptionaiAIBuilderPage() {
	return (
		<>
			<Helmet>
				<title>AI Itinerary Credits</title>
			</Helmet>
			<AIBuilderUsageView />
		</>
	)
}
